import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { PainStory } from './components/PainStory';
import { WhySolutionsFail } from './components/WhySolutionsFail';
import { IsashyExperience } from './components/IsashyExperience';
import { HeadlineShowcase } from './components/HeadlineShowcase';
import { SalesLetter } from './components/SalesLetter';
import { CallToAction } from './components/CallToAction';
import { PageTurn } from './components/PageTurn';
import { Navbar } from './components/Navbar';
import { BookingPopup } from './components/BookingPopup';
import { Location } from './components/Location';
export function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [lang, setLang] = useState<'en' | 'es'>('en');
  function openBooking() {
    setBookingOpen(true);
  }
  function toggleLang() {
    setLang(prev => prev === 'en' ? 'es' : 'en');
  }
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-dark selection:bg-brand-gold selection:text-brand-dark overflow-x-hidden" data-id="element-0">
      <Navbar lang={lang} onToggleLang={toggleLang} onBook={openBooking} data-id="element-1" />
      <Hero onBook={openBooking} lang={lang} data-id="element-2" />
      <PageTurn direction="right" data-id="element-3">
        <PainStory lang={lang} data-id="element-4" />
      </PageTurn>
      <PageTurn direction="left" data-id="element-5">
        <WhySolutionsFail lang={lang} data-id="element-6" />
      </PageTurn>
      <PageTurn direction="right" data-id="element-7">
        <IsashyExperience lang={lang} data-id="element-8" />
      </PageTurn>
      <PageTurn direction="left" data-id="element-9">
        <HeadlineShowcase lang={lang} data-id="element-10" />
      </PageTurn>
      <PageTurn direction="right" data-id="element-11">
        <SalesLetter lang={lang} data-id="element-12" />
      </PageTurn>
      <PageTurn direction="left" data-id="element-13">
        <Location lang={lang} data-id="element-14" />
      </PageTurn>
      <PageTurn direction="right" data-id="element-15">
        <CallToAction onBook={openBooking} lang={lang} data-id="element-16" />
      </PageTurn>
      <BookingPopup isOpen={bookingOpen} onClose={() => setBookingOpen(false)} lang={lang} data-id="element-17" />
    </div>;
}